import {https,httpsFile} from './http.js';
export function index(search,getGLForExpense){
    return httpsFile().get(`/glAccounts?search=${search}&getGLForExpense=${getGLForExpense}`);
}
